// extracted by mini-css-extract-plugin
module.exports = {"DealMain":"DealMain_DealMain__8yYGV","Show":"DealMain_Show__1a96w","Hide":"DealMain_Hide__jDxMt","Card":"DealMain_Card__HlqDV"};